import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 550460 680037"
    {...props}
  >
    <path
      d="m172159 79954 256074 387801V76274c0-25421 5521-44412 16391-57123C455505 6440 470206 0 488737 0c18991 0 34151 6280 45182 18991 11031 12721 16541 31862 16541 57283v517228c0 57733-23891 86535-71684 86535-11941 0-22661-1690-32312-5210-9500-3370-18531-8881-26801-16231-8421-7511-16081-16241-23281-26352-7201-9950-14401-20211-21602-30631L124977 218712v385051c0 25111-5821 44112-17451 56973-11801 12861-26812 19301-45033 19301-18841 0-34001-6440-45332-19451C5670 647565 0 628574 0 603763V96495c0-21601 2450-38442 7200-50693 5671-13480 15161-24511 28332-33081C48713 4290 62953 0 78114 0c12101 0 22361 1990 30782 5820 8580 3991 16081 9191 22521 15781 6431 6581 13011 15011 19751 25572 6741 10420 13791 21291 20991 32781z"
      style={{
        fill: "#2b2a29",
        fillRule: "nonzero",
      }}
      className="fill"

    />
  </svg>
)
export default SvgComponent
